import api from '../api/api-appdsv';
import apiDigital from '../api/api-digital';

export const findData = {
  GetCEP: async (value: string) => await api.get(`/correios/endereco/${value}`),
  GetMunicipio: async () => await api.get(`/municipios/`),
  GetTipoOcupação: async () => await api.get(`/dominio?dominio=TIPO_OCUPACAO`),
  GetTipoEmpresa: async () => await api.get(`/dominio?dominio=TIPO_EMPRESA`),
  GetPorteEmpresa: async () => await api.get(`/dominio?dominio=PORTE_EMPRESA`),
  GetClasseEconomicaEmpresa: async () =>
    await api.get(`/dominio?dominio=CLASSE_ECONOMICA_SETOR`),
  GetAtividadesEconomicas: async () =>
    await apiDigital.get(
      '/financeira/consultaCNAE?client_id=189e38d0-6642-49d6-bb76-d28d24049fbe'
    ),
  GetNacionalidades: async () => await api.get(`/nacionalidades/`),
  GetRamosAtividade: async () => await api.get(`/ramo-atividade/listar`),
};
